<template>
  <div class="a-empty">
    <div class="a-empty__mochi">
      <MochiCharacter :size="size" :expr="expr" />
    </div>
    <h4 v-if="title" class="a-empty__title">{{ title }}</h4>
    <p v-if="desc" class="a-empty__desc">{{ desc }}</p>
    <div v-if="$slots.action" class="a-empty__action">
      <slot name="action" />
    </div>
  </div>
</template>

<script>
import MochiCharacter from '@/components/Pineapple/MochiCharacter.vue';

export default {
  name: 'AEmpty',
  components: { MochiCharacter },
  props: {
    title: { type: String, default: '데이터가 없습니다' },
    desc:  { type: String, default: '' },
    size:  { type: [String, Number], default: 130 },
    expr:  { type: String, default: 'sleepy' },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/pineapple';

.a-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 32px 16px 28px;
  gap: 12px;
  color: $p-ink-mid;
}

.a-empty__mochi {
  // Auto size — Mochi SVG aspect is 200:240 (taller than wide).
  // Fixed dimensions caused vertical overflow and overlapped the title.
  display: inline-flex;
  margin-bottom: 4px;
}

.a-empty__title {
  margin: 0;
  font-size: 15px;
  font-weight: 800;
  color: $p-ink;
}

.a-empty__desc {
  margin: 0;
  font-size: 13px;
  color: $p-ink-mid;
  max-width: 360px;
}

.a-empty__action {
  margin-top: 8px;
}
</style>
